<template>
    <div>
        <template v-if="label != ''">
            <div class="label text-14 lg:text-base font-bold mb-6">
                {{ label }} <span v-if="isOptional"
                    class="text-a-brown-9f8273 text-12 lg:text-14 font-bold">({{ lblOptional }})</span>
            </div>
        </template>
        <div class="controls">
            <template v-for="(controller, idx) of controllers" :key="`qty-item-${idx}`">
                <QuantityControl v-model="values[idx]" :controller="controller" :textKey="textKey" @hasChange="hasChange()" isGroup extraLabel="price">
                </QuantityControl>
            </template>
        </div>
    </div>
</template>
<script>
// composable
import { onMounted, inject } from 'vue'
import { useQuantityControlGroup } from '../composable/useQuantityControl'
// component
import QuantityControl from './QuantityControl.vue'

export default {
    name: 'QuantityControlGroup',
    props: {
        modelValue: {},
        label: {
            type: String,
            default: ""
        },
        items: {
            type: Array,
            default: () => []
        },
        isOptional: {
            type: Boolean,
            default: false
        },
        textKey: {
            type: String,
            default: "name"
        },
        selectedOptions: {
            type: Array,
            default: () => []
        },
    },
    components: {
        QuantityControl,
    },
    mixins: [],
    emits: ["update:modelValue", "onReady"],
    data: function () { return {} },
    computed: {},
    setup: function (props, context) {
        const { lbl } = inject("LocaleStore")
        const lblOptional = lbl.value.productDetail.optional

        const { values, controllers } = useQuantityControlGroup(props.items)

        const hasChange = function () {
            context.emit("update:modelValue", values.value)
        }

        onMounted(()=>{
            context.emit("update:modelValue", values.value)
            context.emit("onReady")
        })

        return {
            controllers,
            values,
            hasChange,
            lblOptional
        }
    },
    mounted: function () { },
    methods: {}
}
</script>
